import { find } from 'lodash'

export const getServiceTypes = (state) =>
  state?.serviceTypes?.byId ?? {}

export const getNewCurrentServiceType = (state, uuid) => {
  const allNewServiceTypes = getServiceTypes(state)
  const newCurrentServiceType = find(
    allNewServiceTypes,
    (serviceType) => serviceType.uuid === uuid
  )
  return newCurrentServiceType ?? {}
}

export const getIsServiceTypeLoading = (state) =>
  state?.serviceTypes?.isLoading
